module.exports = __webpack_public_path__ + "img/icon_map_53_off_100.0af8cd5f.png";